import {
  productEventEmitter,
  ProductEventPayload,
} from "@made-people/grease-product";
import { useEffect } from "react";
import { gtmReturnIdProduct } from "../mm-gtm-helpers";
import { useMmGtm } from "../mm-gtm-context";

export const MmGtmEventSelectSize = () => {
  const { pusher } = useMmGtm();

  useEffect(() => {
    const handleEvent = (
      params: ProductEventPayload["productVariantSelected"],
    ) => {
      const waistSize = params.productData.variant.dimensions.find(
        (dimension) => dimension.dimensionKey === "waist-size",
      )?.value;
      const cupSize = params.productData.variant.dimensions.find(
        (dimension) => dimension.dimensionKey === "cup-size",
      )?.value;

      let selectedSize = params.productData.variant.label;
      if (waistSize && cupSize) {
        selectedSize = `${cupSize} / ${waistSize}`;
      }

      pusher({
        event: "select_size",
        eventLabel: params.productData.base.content.name,
        ecommerce: {
          selectSize: {
            selectedSize,
            productSku: gtmReturnIdProduct(
              params.productData.base,
              selectedSize,
            ),
          },
        },
      });
    };

    productEventEmitter.on("productVariantSelected", handleEvent);
    return () => {
      productEventEmitter.off("productVariantSelected", handleEvent);
    };
  }, []);

  return null;
};
